<section
  class="analogue-panel"
  [class.analogue-panel--embedded]="embedded"
  [class.analogue-panel--dialog]="dialogMode"
  [class.analogue-panel--card]="cardMode"
>
  <div class="analogue-panel__header" *ngIf="!hideHeader">
    <div>
      <h3>Аналоги товара</h3>
      <p *ngIf="productTitle">Связи для: {{ productTitle }}</p>
    </div>

    <div class="analogue-panel__header-actions">
      <ng-container *ngIf="hasLoadableSupplierSources(); else disabledSupplierLoadButton">
        <button
          *ngIf="!hasMultipleLoadableSupplierSources(); else supplierLoadMenuButton"
          mat-flat-button
          color="primary"
          type="button"
          [disabled]="isPrimarySupplierLoading()"
          (click)="loadPrimarySupplierAnalogues()"
        >
          <mat-icon>{{ isPrimarySupplierLoading() ? 'hourglass_top' : 'cloud_download' }}</mat-icon>
          Загрузить аналоги
        </button>
      </ng-container>

      <ng-template #supplierLoadMenuButton>
        <button
          mat-flat-button
          color="primary"
          type="button"
          [matMenuTriggerFor]="supplierLoadMenu"
        >
          <mat-icon>cloud_download</mat-icon>
          Загрузить аналоги
          <mat-icon>expand_more</mat-icon>
        </button>
      </ng-template>

      <ng-template #disabledSupplierLoadButton>
        <button mat-stroked-button type="button" disabled>
          <mat-icon>cloud_off</mat-icon>
          Загрузка не настроена
        </button>
      </ng-template>

      <button
        mat-stroked-button
        type="button"
        routerLink="/settings/supplier_analogue_settings/list"
      >
        <mat-icon>tune</mat-icon>
        Настройка загрузки
      </button>

      <button mat-stroked-button color="primary" type="button" (click)="openAddManualDialog()">
        <mat-icon>add_link</mat-icon>
        Добавить вручную
      </button>
    </div>
  </div>

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <mat-menu #supplierLoadMenu="matMenu">
    <button mat-menu-item (click)="loadAllSupplierAnalogues()" [disabled]="isAnySupplierLoading()">
      <mat-icon>{{ isAnySupplierLoading() ? 'hourglass_top' : 'cloud_download' }}</mat-icon>
      <span>Все включенные интеграции</span>
    </button>
    <button
      mat-menu-item
      *ngFor="let source of loadableSupplierSources"
      (click)="loadSupplierAnalogues(source)"
      [disabled]="isSupplierLoading(source.contractId)"
    >
      <mat-icon>{{
        isSupplierLoading(source.contractId) ? 'hourglass_top' : 'cloud_download'
      }}</mat-icon>
      <span
        >{{ source.providerName
        }}<span *ngIf="source.contractNumber"> · {{ source.contractNumber }}</span></span
      >
    </button>
  </mat-menu>

  <div class="analogue-panel__toolbar">
    <div class="analogue-panel__tabs">
      <button
        type="button"
        class="analogue-tab"
        *ngFor="let tab of tabs"
        [class.analogue-tab--active]="activeTab === tab.key"
        (click)="activeTab = tab.key"
      >
        {{ tab.label }}
        <span>{{ getTabCount(tab.key) }}</span>
      </button>
    </div>

    <button
      mat-stroked-button
      type="button"
      class="analogue-panel__supplier-filter"
      *ngIf="supplierFilterSources.length > 1"
      [matMenuTriggerFor]="supplierFilterMenu"
    >
      <mat-icon>filter_list</mat-icon>
      {{ getSupplierFilterLabel() }}
      <mat-icon>expand_more</mat-icon>
    </button>

    <mat-menu #supplierFilterMenu="matMenu" class="analogue-panel__supplier-filter-menu">
      <button
        mat-menu-item
        type="button"
        *ngFor="let source of supplierFilterSources"
        (click)="toggleSupplierFilter(source.contractId)"
      >
        <mat-icon>{{
          isSupplierFilterSelected(source.contractId) ? 'check_box' : 'check_box_outline_blank'
        }}</mat-icon>
        <span
          >{{ source.providerName
          }}<span *ngIf="source.contractNumber"> · {{ source.contractNumber }}</span></span
        >
      </button>
    </mat-menu>
  </div>

  <div class="analogue-panel__state" *ngIf="errorMessage">{{ errorMessage }}</div>
  <div class="analogue-panel__state" *ngIf="!loading && !errorMessage && !visibleItems.length">
    Для выбранного набора аналогов данные пока отсутствуют.
  </div>

  <div class="analogue-panel__table-shell" *ngIf="!loading && !errorMessage && visibleItems.length">
    <table class="analogue-table">
      <thead>
        <tr>
          <th class="analogue-table__id" *ngIf="!cardMode">ID</th>
          <th class="analogue-table__image" matTooltip="Картинка"><mat-icon aria-label="Картинка">image</mat-icon></th>
          <th class="analogue-table__product">Товар</th>
          <th class="analogue-table__brand">Производитель</th>
          <th class="analogue-table__article">Артикул</th>
          <th class="analogue-table__price">Цена</th>
          <th class="analogue-table__auto-price">Авто цена</th>
          <th class="analogue-table__stocks" matTooltip="Остатки по складам">Склады</th>
          <th class="analogue-table__provider" matTooltip="Наличие у поставщика">Поставщики</th>
          <th class="analogue-table__cell" matTooltip="Адрес хранения на складе">Адрес</th>
          <th class="analogue-table__actions">Действия</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let item of visibleItems; trackBy: trackByProductId"
          (contextmenu)="onRightClick($event, item)"
        >
          <td data-label="ID" class="analogue-table__id" *ngIf="!cardMode">
            <button
              type="button"
              class="analogue-table__id-link"
              [matTooltip]="'Скопировать товар'"
              matTooltipPosition="above"
              [attr.aria-label]="'Скопировать товар #' + item.product.id"
              (click)="copyProductSummary(item)"
            >
              {{ item.product.id }}
            </button>
          </td>

          <td data-label="Картинка" class="analogue-table__image">
            <a
              class="analogue-product-cell__image"
              [routerLink]="['/product', item.product.id]"
              target="_blank"
              (mouseenter)="
                showImagePreview($event, getProductImageUrl(item), item.product.description)
              "
              (mousemove)="moveImagePreview($event)"
              (mouseleave)="hideImagePreview()"
            >
              <img
                *ngIf="getProductImageUrl(item); else emptyProductImage"
                [src]="getProductImageUrl(item)!"
                [alt]="item.product.description"
              />
              <ng-template #emptyProductImage>
                <div class="analogue-product-cell__image-placeholder">
                  <mat-icon>image_not_supported</mat-icon>
                </div>
              </ng-template>
            </a>
          </td>

          <td data-label="Товар" class="analogue-table__product">
            <div class="analogue-product-cell">
              <div class="analogue-product-cell__main analogue-copyable-text">
                <a
                  class="analogue-product-cell__title analogue-copyable-text__value"
                  [matTooltip]="item.product.description"
                  [routerLink]="['/product', item.product.id]"
                  target="_blank"
                >
                  {{ item.product.description }}
                </a>
                <button
                  mat-icon-button
                  type="button"
                  class="analogue-copyable-text__button"
                  [matTooltip]="'Скопировать наименование'"
                  matTooltipPosition="above"
                  aria-label="Скопировать наименование"
                  (click)="copyProductName(item)"
                >
                  <mat-icon>content_copy</mat-icon>
                </button>
              </div>
            </div>
          </td>

          <td data-label="Производитель" class="analogue-table__brand">
            <div class="analogue-brand-cell">
              <a
                class="analogue-brand-cell__logo"
                [routerLink]="['/brand', item.product.brand?.id]"
                target="_blank"
              >
                <img
                  *ngIf="getBrandLogoUrl(item); else noBrandLogo"
                  [src]="getBrandLogoUrl(item)!"
                  [alt]="item.product.brand?.description"
                />
                <ng-template #noBrandLogo>
                  <div class="analogue-brand-cell__logo-placeholder">
                    {{ item.product.brand?.description?.slice(0, 1) }}
                  </div>
                </ng-template>
              </a>

              <div class="analogue-brand-cell__meta">
                <div class="analogue-copyable-text analogue-copyable-text--brand">
                  <a
                    class="analogue-brand-cell__title analogue-copyable-text__value"
                    [routerLink]="['/brand', item.product.brand?.id]"
                    target="_blank"
                  >
                    {{ item.product.brand?.description }}
                  </a>
                  <button
                    mat-icon-button
                    type="button"
                    class="analogue-copyable-text__button"
                    [matTooltip]="'Скопировать производителя'"
                    matTooltipPosition="above"
                    aria-label="Скопировать производителя"
                    (click)="copyBrandName(item)"
                  >
                    <mat-icon>content_copy</mat-icon>
                  </button>
                </div>

                <div
                  class="analogue-brand-cell__rating"
                  *ngIf="getBrandRatingValue(item); else brandWithoutRating"
                >
                  <span
                    class="analogue-brand-cell__stars"
                    [matTooltip]="'Внутренний рейтинг: ' + getBrandRatingValue(item) + ' из 5'"
                  >
                    <mat-icon *ngFor="let _ of getBrandRatingRange(item)">star</mat-icon>
                  </span>
                  <span class="analogue-brand-cell__rating-value"
                    >{{ getBrandRatingValue(item) }}/5</span
                  >
                </div>

                <ng-template #brandWithoutRating>
                  <span class="analogue-brand-cell__rating analogue-brand-cell__rating--empty"
                    >Без рейтинга</span
                  >
                </ng-template>
              </div>
            </div>
          </td>

          <td data-label="Артикул" class="analogue-table__article">
            <div class="analogue-table__article-cell">
              <button
                type="button"
                class="analogue-table__article-link analogue-table__article-button"
                [matTooltip]="'Скопировать артикул'"
                matTooltipPosition="above"
                (click)="copyArticle(item)"
              >
                {{ item.product.article }}
              </button>
            </div>
          </td>

          <td data-label="Цена" class="analogue-table__price">
            <span
              class="analogue-table__price-value"
              [matTooltip]="getDisplayPriceTooltip(item.product)"
              [matTooltipDisabled]="!getDisplayPriceTooltip(item.product)"
              matTooltipPosition="left"
            >
              {{ formatPriceHryvnia(getDisplayPrice(item.product)) }}
            </span>
          </td>

          <td data-label="Автоцена" class="analogue-table__auto-price">
            <button
              mat-icon-button
              type="button"
              class="analogue-table__auto-price-button"
              [class.analogue-table__auto-price-button--enabled]="item.product.updateRetail"
              [class.analogue-table__auto-price-button--disabled]="!item.product.updateRetail"
              [disabled]="isTogglingUpdateRetail(item.product.id)"
              [matTooltip]="
                item.product.updateRetail
                  ? 'Автообновление цены включено'
                  : 'Автообновление цены выключено'
              "
              [attr.aria-label]="
                item.product.updateRetail
                  ? 'Выключить автообновление цены'
                  : 'Включить автообновление цены'
              "
              (click)="toggleUpdateRetail(item)"
            >
              <mat-icon>{{
                isTogglingUpdateRetail(item.product.id)
                  ? 'hourglass_top'
                  : item.product.updateRetail
                  ? 'lock_open'
                  : 'lock'
              }}</mat-icon>
            </button>
          </td>

          <td data-label="Остатки по складам" class="analogue-table__stocks">
            <div
              class="analogue-table__stock-list"
              *ngIf="getStockTiles(item).length; else noAnalogueStocks"
            >
              <span
                class="stock-tile"
                *ngFor="let stock of getStockTiles(item)"
                [class.stock-tile--available]="stock.quantity > 0"
                [class.stock-tile--zero]="stock.quantity === 0"
                [class.stock-tile--primary]="stock.isPrimary"
                [matTooltip]="stock.tooltip"
                matTooltipPosition="above"
              >
                {{ stock.quantityLabel }}
              </span>
            </div>
            <ng-template #noAnalogueStocks>
              <span class="analogue-row__empty">Нет</span>
            </ng-template>
          </td>

          <td data-label="Наличие у поставщика" class="analogue-table__provider">
            <div class="analogue-table__provider-list">
              <span
                class="stock-tile"
                *ngFor="let providerTile of getProviderTiles(item)"
                [class.stock-tile--available]="providerTile.quantity > 0"
                [class.stock-tile--zero]="providerTile.quantity === 0"
                [matTooltip]="providerTile.tooltip"
                matTooltipClass="provider-availability-tooltip"
                matTooltipPosition="above"
              >
                {{ providerTile.quantityLabel }}
              </span>
            </div>
          </td>

          <td data-label="Адрес хранения на складе" class="analogue-table__cell">
            <button
              type="button"
              class="analogue-table__cell-button"
              (click)="openStockDetails(item)"
              [matTooltip]="'Управление адресным хранением'"
            >
              {{ getPrimaryStock(item)?.cell || 'Нет размещения' }}
            </button>
          </td>

          <td data-label="Действия" class="analogue-table__actions">
            <div class="analogue-table__action-buttons">
              <button
                *ngIf="item.sourceKind === 'MANUAL' && item.relationType === 'ANALOG'"
                mat-icon-button
                type="button"
                class="analogue-table__action-button analogue-table__action-button--warn"
                [disabled]="isManualLoading(item.product.id)"
                [matTooltip]="'Удалить аналог'"
                (click)="removeManual(item)"
              >
                <mat-icon>{{
                  isManualLoading(item.product.id) ? 'hourglass_top' : 'link_off'
                }}</mat-icon>
              </button>
              <button
                *ngIf="item.sourceKind !== 'MANUAL' || item.relationType === 'OE'"
                mat-icon-button
                type="button"
                class="analogue-table__action-button"
                [disabled]="isManualLoading(item.product.id)"
                [matTooltip]="'Добавить в ручные аналоги'"
                (click)="promoteToManual(item)"
              >
                <mat-icon>{{
                  isManualLoading(item.product.id) ? 'hourglass_top' : 'playlist_add_link'
                }}</mat-icon>
              </button>
              <button
                *ngIf="item.sourceKind === 'SUPPLIER'"
                mat-icon-button
                type="button"
                class="analogue-table__action-button analogue-table__action-button--warn"
                [disabled]="isExcludingSupplier(item.product.id)"
                [matTooltip]="'Удалить и больше не загружать от поставщика'"
                (click)="excludeSupplierAnalogue(item)"
              >
                <mat-icon>{{
                  isExcludingSupplier(item.product.id) ? 'hourglass_top' : 'block'
                }}</mat-icon>
              </button>
              <button
                mat-icon-button
                type="button"
                class="analogue-table__action-button"
                [matTooltip]="'История движения'"
                (click)="openMove(item)"
              >
                <mat-icon>history</mat-icon>
              </button>
              <div
                class="analogue-table__cart-control"
                *ngIf="productInCart(item.product.id); else analogueAddToCartButton"
              >
                <input
                  type="number"
                  min="1"
                  step="1"
                  [value]="getProductCartQuantity(item.product.id)"
                  (input)="changeCartQuan(item, $event)"
                  aria-label="Количество в корзине"
                />
                <button
                  mat-icon-button
                  type="button"
                  class="analogue-table__action-button analogue-table__action-button--warn"
                  [matTooltip]="'Убрать из корзины'"
                  (click)="removeFromCart(item.product.id)"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </div>
              <ng-template #analogueAddToCartButton>
                <button
                  mat-icon-button
                  type="button"
                  class="analogue-table__action-button"
                  [disabled]="isAddingToCart(item.product.id)"
                  [matTooltip]="'Добавить в корзину'"
                  (click)="addToCart(item)"
                >
                  <mat-icon>{{
                    isAddingToCart(item.product.id) ? 'hourglass_top' : 'add_shopping_cart'
                  }}</mat-icon>
                </button>
              </ng-template>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div
    class="analogue-context-anchor"
    [style.left]="contextMenuPosition.x"
    [style.top]="contextMenuPosition.y"
    [matMenuTriggerFor]="rowContextMenu"
  ></div>

  <mat-menu #rowContextMenu="matMenu">
    <ng-template matMenuContent let-item="item">
      <button mat-menu-item (click)="openContextAnalogies(item)">
        <mat-icon>hub</mat-icon>
        Аналоги
      </button>

      <button
        mat-menu-item
        *ngIf="item.sourceKind === 'MANUAL' && item.relationType === 'ANALOG'"
        [disabled]="isManualLoading(item.product.id)"
        (click)="removeManual(item)"
      >
        <mat-icon>{{ isManualLoading(item.product.id) ? 'hourglass_top' : 'link_off' }}</mat-icon>
        Удалить аналог
      </button>

      <button
        mat-menu-item
        *ngIf="item.sourceKind !== 'MANUAL' || item.relationType === 'OE'"
        [disabled]="isManualLoading(item.product.id)"
        (click)="promoteToManual(item)"
      >
        <mat-icon>{{
          isManualLoading(item.product.id) ? 'hourglass_top' : 'playlist_add_link'
        }}</mat-icon>
        Добавить в ручные
      </button>

      <button
        mat-menu-item
        *ngIf="item.sourceKind === 'SUPPLIER'"
        [disabled]="isExcludingSupplier(item.product.id)"
        (click)="excludeSupplierAnalogue(item)"
      >
        <mat-icon>{{ isExcludingSupplier(item.product.id) ? 'hourglass_top' : 'block' }}</mat-icon>
        Не загружать от поставщика
      </button>

      <button mat-menu-item (click)="copyArticle(item)">
        <mat-icon>content_copy</mat-icon>
        Скопировать артикул
      </button>

      <button mat-menu-item (click)="openContextSetNewPrice(item)">
        <mat-icon>edit</mat-icon>
        Новая цена
      </button>

      <button mat-menu-item (click)="openContextUpdateName(item)">
        <mat-icon>edit_note</mat-icon>
        Изменить наименование
      </button>

      <button mat-menu-item (click)="openContextAddImage(item)">
        <mat-icon>image</mat-icon>
        Добавить изображение
      </button>

      <button
        mat-menu-item
        [disabled]="isImportingFromExist(item.product.id)"
        (click)="openContextImportFromExist(item)"
      >
        <mat-icon>cloud_download</mat-icon>
        Загрузить с Exist
      </button>

      <button mat-menu-item (click)="openContextRemoveDouble(item)">
        <mat-icon>merge</mat-icon>
        Слить/удалить дубль
      </button>

      <button mat-menu-item (click)="openContextAddBarcode(item)">
        <mat-icon>qr_code</mat-icon>
        Добавить штрих-код
      </button>

      <button mat-menu-item (click)="openContextQuickPrint(item)">
        <mat-icon>print</mat-icon>
        Распечатать штрих-код
      </button>

      <button mat-menu-item (click)="openMove(item)">
        <mat-icon>history</mat-icon>
        История движения
      </button>

      <button
        mat-menu-item
        [disabled]="isAddingToCart(item.product.id) || !user?.cart?.id"
        (click)="addToCart(item)"
      >
        <mat-icon>{{
          isAddingToCart(item.product.id) ? 'hourglass_top' : 'add_shopping_cart'
        }}</mat-icon>
        Добавить в корзину
      </button>

      <button
        mat-menu-item
        [disabled]="isTogglingPublic(item.product.id)"
        (click)="openContextTogglePublic(item)"
      >
        <mat-icon>public</mat-icon>
        Переключить продажи
      </button>

      <button mat-menu-item (click)="openContextFolders(item)">
        <mat-icon>folder</mat-icon>
        Папки
      </button>

      <button mat-menu-item (click)="openContextProps(item)">
        <mat-icon>settings</mat-icon>
        Характеристики
      </button>
    </ng-template>
  </mat-menu>

  <div
    class="analogue-image-hover-preview"
    *ngIf="hoveredImageUrl"
    [style.left.px]="hoveredImagePreviewLeft"
    [style.top.px]="hoveredImagePreviewTop"
  >
    <img [src]="hoveredImageUrl" [alt]="hoveredImageTitle || 'Предпросмотр изображения товара'" />
  </div>
</section>
